<template>
    <div class="main">
        <my_menu active_name="2-0" :open_active="['2']"></my_menu>

        <div class="content">
            <div class="div_options">
                <Button type="primary" @click="click_add_ak">
                    <Icon type="md-add" /> 更新密钥
                </Button>
            </div>
            <div class="card_main">
                <div v-for="(item, i) in ak_list" :key="i" class="card">
                    <div class="card_line">
                        <div class="card_field">
                            当前状态：
                        </div>
                        {{ item.is_disabling == 1 ? '停用' : "正常" }}
                        <Icon size="20" style="margin-left:10px" color="#eb0808" v-if=" item.is_disabling == 1" type="md-remove-circle" />
                        <Icon size="20" style="margin-left:10px" color="#0bbb05" v-if=" item.is_disabling == 0" type="ios-happy" />
                    </div>
                    <div class="card_line">
                        <div class="card_field">
                            创建时间：
                        </div>
                        {{ item.create_time }}
                    </div>
                    <div class="card_line">
                        <div class="card_field">
                            Key:
                        </div>
                        {{ item.key }}
                    </div>
                    <div class="card_line">
                        <div class="card_field">
                            私钥：
                        </div>
                        {{ item.private_key }}
                    </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script>
import my_menu from '@/component/admin/menu/menu.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度


            ak_list: [],

        }
    },

    mounted() {
        this.window_change()
        this.get_ak_list()
    },

    methods: {


        click_add_ak() {
            var that = this
            this.$Modal.confirm({
                title: '更新AK(危险操作)',
                content: '添加后旧的AK会停用，可能会影响现有系统，请替换完原有AK后再继续，是否继续？',
                onOk: () => {
                    that.add_ak()
                },
                onCancel: () => {

                }
            })
        },

        //新增密钥
        add_ak() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/ak/add_ak", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_ak_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },



        //获取密钥列表
        get_ak_list() {
            var that = this
            var obj = {
                page: this.page
            }
            http("post", process.env.VUE_APP_HOST + "/ak/ak_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.ak_list = res.data.key_list

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.card_main {}

.card_field {
    width: 100px;
    flex-shrink: 0;
}

.card_line {
    margin-bottom: 10px;
    display: flex;
    align-items: center;

}

.color{
    color:#0bbb05
}

.card {
    padding: 10px;
    border-bottom: 1px solid rgb(242, 242, 242)
}

.div_options {
    display: flex;
    justify-content: flex-end;
}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    overflow: auto;
    padding: 10px;
    width: calc(100% - 220px);
    background-color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    height: calc(100vh - 20px);
    border-radius: 5px;
}

.main {
    background: #ececec;
    min-height: 100vh;
}
</style>